import React from "react";

class Closer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                color: "darkblue",
                fontWeight: "bold"
            },
            ident: "closer"
        }
    }

    handleClose = (ev) => {
        ev.currentTarget.parentElement.style.display = "none";
        ev.currentTarget.parentElement.previousSibling.style.borderBottom = "1px solid rgb(150, 150, 150)";
    }

    render() {
        return (

            <button className={this.state.ident} style={this.state.style} onClick={(e) => this.handleClose(e)}>X Close</button>


        )
    }
}

export default Closer;


// WEBPACK FOOTER //
// ./src/closer.js